<script setup lang="ts">
import type { NavigationModel } from '@/types/navigationModel';

defineOptions({
  name: 'MopHeaderMenuOverlay',
});

defineProps({
  category: {
    type: Object as PropType<NavigationModel>,
    required: true,
  },
});
</script>

<template>
  <nav class="header-menu">
    <MopNavigationTree :nav-item="category" />
  </nav>
</template>

<style lang="scss" scoped>
.header-menu {
  @include z(global, content);

  display: flex;
  flex-direction: column;
  width: calc(100% - 40px); // giving space for close icon
  padding: 0 $global-padding;
  position: relative;

  :deep() {
    .navigation-tree--1 {
      margin-top: $space15;
    }

    .navigation-tree--2 {
      padding: $space10 $space20;
    }

    .navigation-tree--3 {
      padding: $space5 $space20;
    }

    .navigation-tree__item {
      @include text-style(weighted-bold);
      @include link-not-underlined(0, none);

      text-transform: uppercase;
      font-size: 13px;
      line-height: 14px;
      margin: 0;
      display: inline-block;
    }

    .router-link-exact-active {
      @include link-underlined(0);
    }
  }
}
</style>
